import type {ProjectPickerBaseProject as ProjectPickerProject} from '@github-ui/item-picker-project'
import {ProjectPicker} from '@github-ui/item-picker-project-tsq'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {ActionList} from '@primer/react'

import {
  ProjectsSection,
  ProjectsSectionFallback,
  ProjectsSectionHeader,
  ReadonlyProjectsSectionHeader,
} from './ProjectsSection'
import styles from './ProjectsSection.module.css'

type CreateIssueProjectsSectionProps = {
  owner: string
  repo: string
  projects: ProjectPickerProject[]
  readonly: boolean
  onSelectionChange: (value: ProjectPickerProject[]) => void
}
export const CreateIssueProjectsSection = ({
  owner,
  repo,
  projects,
  readonly,
  onSelectionChange,
  ...sharedConfigProps
}: CreateIssueProjectsSectionProps) => {
  const headingLabelId = 'create-issue-sidebar-projects-section-heading'
  const sectionHeader = readonly ? (
    <ReadonlyProjectsSectionHeader />
  ) : (
    <ProjectPicker
      pickerId={'create-issue-projects-picker'}
      owner={owner}
      repo={repo}
      selectedProjects={projects}
      readonly={readonly}
      onSave={onSelectionChange}
      anchorElement={props => <ProjectsSectionHeader {...props} id={headingLabelId} />}
      {...sharedConfigProps}
    />
  )

  return (
    <ErrorBoundary fallback={<ProjectsSectionFallback />}>
      <ProjectsSection sectionHeader={sectionHeader} hasItems={projects.length > 0}>
        {projects.length > 0 && (
          <ActionList aria-labelledby={headingLabelId} variant="full" className={styles.projectActionList}>
            {projects.map(project => (
              <ActionList.LinkItem key={project.id} href={project.url} className={styles.ActionList_LinkItem}>
                {project.title}
              </ActionList.LinkItem>
            ))}
          </ActionList>
        )}
      </ProjectsSection>
    </ErrorBoundary>
  )
}
